// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__kBfsI","footer":"ModalFilter_footer___4lOo"};